import get from 'lodash/get';
import * as searchPageActions from '../../action_creators/search/search_page_action_creators';
import log from '../../../services/logger_service';

import asyncAllFeedActions from '../homepage/async_all_feed_actions';
import asyncSearchActions from './async_search_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(searchPageActions.searchPageLoading());
    return Promise.all([
      asyncSearchActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch),
      asyncAllFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(searchPageActions.searchPageLoaded({}, store));
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in search page actions, message: ${err.message}`
          );
        }
        dispatch(searchPageActions.searchPageLoadError(err, store));
      });
  };
}
